var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"btn",class:_vm.buttonClasses,attrs:{"type":_vm.tag === 'button' ? _vm.nativeType : '',"disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[(_vm.loading)?[_c('i',{staticClass:"fas fa-spinner fa-spin"})]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }